import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  const onClickVisitLink = (url) => {
    window.open(url, "_blank");
  };
  return (
    <div className="bg-primary-500 py-6">
      <div className="mx-[15%] md:mx-[10%] sm:mx-7 flex justify-between text-ys-pewter-500 sm:text-sm sm:flex-col h-full">
        <div className="flex sm:justify-between">
          <div className="flex flex-col mr-4 sm:mr-1.5">
            <NavLink to={``} className="hover:text-white hover:underline">
              Home
            </NavLink>
            <NavLink to={`/about`} className="hover:text-white hover:underline">
              About
            </NavLink>
            <NavLink
              to={`/content`}
              className="hover:text-white hover:underline"
            >
              Content
            </NavLink>
            <NavLink
              to={`/premise`}
              className="hover:text-white hover:underline"
            >
              Premise
            </NavLink>
            <NavLink
              to={`/component`}
              className="hover:text-white hover:underline"
            >
              Component
            </NavLink>
          </div>
          <div className="flex flex-col ml-4 sm:ml-1.5">
            <NavLink
              className="hover:text-white hover:underline whitespace-nowrap"
              target="_blank"
              onClick={() =>
                onClickVisitLink(
                  "https://www.linkedin.com/in/yonathan-simbolon-850229221/"
                )
              }
            >
              Find Author↗
            </NavLink>
            <NavLink
              className="hover:text-white hover:underline whitespace-nowrap"
              target="_blank"
              onClick={() =>
                onClickVisitLink(
                  "mailto:yonathansimbolon10@gmail.com?subject=Your Email Subject&body=Hi! Thanks for sending me email. Why you want to reach me?"
                )
              }
            >
              Email Author↗
            </NavLink>
          </div>
        </div>
        <div className="w-[400px] sm:w-full text-sm ml-7 sm:ml-0 sm:mt-4 flex flex-col justify-between">
          <p className="mb-3">
            Maintained by the{" "}
            <span
              className="text-ys-pewter-200 hover:underline cursor-pointer font-semibold font-mono hover:text-white"
              onClick={() =>
                onClickVisitLink(
                  "https://www.linkedin.com/in/yonathan-simbolon-850229221/"
                )
              }
            >
              Author
            </span>
            , this bank of
            <b> reusable</b> and <b>modifiable</b> react components, will also
            be <b>updated</b> with simple <b>standard</b> rule for choosing
            color, typography, etc.
          </p>
          <p>
            Latest Update:{" "}
            <b className="font-mono text-ys-pewter-200">25 February 2025</b>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
